module.exports = __webpack_public_path__ + "img/green-btn.415bdec.png";